import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import Logo from "./Logo";
import { useI18n } from "../data/i18n";

const FB_LINK = "https://www.facebook.com/share/18nvmz6Z2e/?mibextid=wwXIfr";
const IG_LINK = "https://www.instagram.com/casabala.restaurant?igsh=anVoZ2cwZTc4OXB1";
const DIGITAL_EIGHT = "https://www.instagram.com/digitalei8ht/";

// ТОЧНИЯТ ЛИНК ЗА GOOGLE MAPS
const GOOGLE_MAPS_LINK = "https://www.google.com/maps/place/CASA+BALA/@42.6599048,23.3357057,19z/data=!4m6!3m5!1s0x40aa8529e29d0951:0x82be682f65a0476f!8m2!3d42.6599038!4d23.3363494!16s%2Fg%2F11yr37m52f?entry=ttu";

const Footer = () => {
  const { t } = useI18n();
  const navLinks = [
    { key: "nav.home", path: "/" },
    { key: "nav.menu", path: "/menu" },
    { key: "nav.reservation", path: "/reservation" },
    { key: "nav.video", path: "/videos/casa-bala-restaurant-sofia" },
    { key: "nav.gallery", path: "/gallery" },
    { key: "footer.our_chefs", path: "/chefs" },
  ];

  return (
    <footer className="bg-[#070707] border-t border-[#1a1a1a] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <Logo size="md" />
            <p className="text-[#a8a297] text-sm mt-6 leading-relaxed">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-[#e4c590] uppercase tracking-widest text-xs mb-4 font-medium">{t("footer.navigation")}</h4>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-[#cfc7b8] hover:text-[#e4c590] text-sm transition-colors">
                    {t(l.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#e4c590] uppercase tracking-widest text-xs mb-4 font-medium">{t("footer.contacts")}</h4>
            <ul className="space-y-3 text-sm text-[#cfc7b8]">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-[#e4c590] mt-0.5 flex-shrink-0" />
                <a 
                  href={GOOGLE_MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#e4c590] transition-colors"
                >
                  {t("contact.address")}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#e4c590] flex-shrink-0" />
                <a href="tel:+359879201010" className="hover:text-[#e4c590] transition-colors">
                  +359 879 201 010
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={16} className="text-[#e4c590] mt-0.5 flex-shrink-0" />
                <div>
                  <div>{t("common.work_days")}</div>
                  <div>12:00 - 24:00</div>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#e4c590] uppercase tracking-widest text-xs mb-4 font-medium">{t("footer.follow")}</h4>
            <div className="flex gap-3">
              <a
                href={FB_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 border border-[#e4c590]/40 rounded-full flex items-center justify-center text-[#e4c590] hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors"
              >
                <Facebook size={16} />
              </a>
              <a
                href={IG_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 border border-[#e4c590]/40 rounded-full flex items-center justify-center text-[#e4c590] hover:bg-[#e4c590] hover:text-[#0a0a0a] transition-colors"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1f1f1f] pt-6 flex flex-col items-center gap-3 text-xs text-[#7a7468]">
          <p>© {new Date().getFullYear()} CASA BALA. {t("footer.rights")}</p>
          <p className="flex items-center gap-1.5">
            <span>Designed by</span>
            <a
              href={DIGITAL_EIGHT}
              target="_blank"
              rel="noopener noreferrer"
              className="digital-eight"
            >
              <span className="de-digital">Digital</span><span className="de-eight">Eight</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;